import { render, staticRenderFns } from "./UserRecipeTab.vue?vue&type=template&id=d446aca2&scoped=true"
import script from "./UserRecipeTab.vue?vue&type=script&lang=js"
export * from "./UserRecipeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d446aca2",
  null
  
)

export default component.exports